export class InfraEndPointModel {
  InfraId: number;
  TemplateId?: number;
  CountryId?: number;
  WebEndPoint1:string;
  WebEndPoint2:string;
  StorageEndPoint?:string;
  PythonURL?: string;
  RegionName: string;
}
